import script from "./InformativeAlPubblicoSinglePage.vue?vue&type=script&setup=true&lang=js"
export * from "./InformativeAlPubblicoSinglePage.vue?vue&type=script&setup=true&lang=js"

import "./InformativeAlPubblicoSinglePage.vue?vue&type=style&index=0&id=f1eb7d02&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1eb7d02"]])

export default __exports__